import { z } from 'zod';

import { IdSchema, IsoDateSchema } from './common.js';

export const RoutineExerciseSchema = z.object({
  exerciseId: z.string().min(1).max(128),
  targetSets: z.number().int().min(1).max(50),
  targetReps: z.number().int().min(1).max(100),
  targetWeight: z.number().min(0).max(10000),
  restTimerSeconds: z.number().int().min(0).max(3600).default(90),
  notes: z.string().max(2000).default(''),
});
export type RoutineExercise = z.infer<typeof RoutineExerciseSchema>;

export const RoutineSchema = z.object({
  id: IdSchema,
  userId: IdSchema,
  name: z.string().min(1).max(120),
  folder: z.string().max(120).nullable(),
  exercises: z.array(RoutineExerciseSchema).max(50),
  lastUsed: IsoDateSchema.nullable(),
  createdAt: IsoDateSchema,
  updatedAt: IsoDateSchema,
});
export type Routine = z.infer<typeof RoutineSchema>;

export const CreateRoutineSchema = RoutineSchema.omit({
  id: true,
  userId: true,
  lastUsed: true,
  createdAt: true,
  updatedAt: true,
});
export type CreateRoutineInput = z.infer<typeof CreateRoutineSchema>;

export const UpdateRoutineSchema = CreateRoutineSchema.partial();
export type UpdateRoutineInput = z.infer<typeof UpdateRoutineSchema>;

export const CopyRoutineTemplateSchema = z
  .object({
    folder: z.string().min(1).max(120).default('Templates'),
  })
  .strict();
export type CopyRoutineTemplateInput = z.infer<typeof CopyRoutineTemplateSchema>;
